export { default } from './LazyAcademies';
